import { render, staticRenderFns } from "./ProductsBoard.vue?vue&type=template&id=295b596a&scoped=true&"
import script from "./ProductsBoard.vue?vue&type=script&lang=js&"
export * from "./ProductsBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b596a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295b596a')) {
      api.createRecord('295b596a', component.options)
    } else {
      api.reload('295b596a', component.options)
    }
    module.hot.accept("./ProductsBoard.vue?vue&type=template&id=295b596a&scoped=true&", function () {
      api.rerender('295b596a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analyzes/ProductsBoard.vue"
export default component.exports